// Row-sized creative thumbnail for the Performance tables (09-09).
//
// On Meta the image IS the ad, so a creative leaderboard listing only headline
// text answers the wrong question. This is the compact sibling of the campaign
// panels' letterboxed CreativeThumbnail (#4277): same signed-URL asset query,
// sized for a table row, and it never renders a broken-image icon — a missing
// or failed asset falls back to a muted placeholder.
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ImageOff } from 'lucide-react';

import { creativeAssetQueryOptions } from '@/lib/query-options';
import { cn } from '@/lib/utils';

export function CreativeThumb({
  assetId,
  alt,
  className,
}: {
  assetId: number | null | undefined;
  alt: string;
  className?: string;
}) {
  const { data: asset } = useQuery({
    ...creativeAssetQueryOptions(assetId ?? 0),
    enabled: !!assetId,
  });
  const [imgError, setImgError] = useState(false);
  const box = cn('h-9 w-9 shrink-0 rounded border border-gray-200', className);

  if (!assetId || !asset?.signed_url || imgError) {
    return (
      <div className={cn(box, 'flex items-center justify-center bg-gray-50')} aria-hidden>
        <ImageOff className="h-3.5 w-3.5 text-gray-300" />
      </div>
    );
  }
  return (
    <img
      src={asset.signed_url}
      alt={alt}
      loading="lazy"
      onError={() => setImgError(true)}
      className={cn(box, 'object-cover')}
    />
  );
}
